<template>
  <footer class="checkoutFooter">
    <div class="container">
      <nuxt-link :to="link('Home')" class="checkoutFooter__Logo">
        <Icon name="logo" />
      </nuxt-link>

      <div class="checkoutFooter__Links">
        <template v-for="menu in footerMenus">
          <nuxt-link :to="menu.url" :external="menu.external" :target="menu.external ? '_blank' : ''">{{ menu.title }}</nuxt-link>
        </template>

        <p>© Aminess {{ currentYear }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
  const currentYear = new Date().getFullYear();
  const { link, menus } = useSetup();
  const footerMenus = computed(() => menus.value.footerBottom);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_checkoutFooter.scss');
</style>